import { Box } from './box';

export class BoxLarge extends Box
{
  constructor(
      canvas: HTMLCanvasElement,
      svgReference: SVGElement|string,
      options: Object = {})
  {
    const model = {
      boxTop: {
        position: [
            // Front
            -1.097, -1.5,  0.2,
             1.097, -1.5,  0.2,
             1.097,  1.5,  0.2,
            -1.097,  1.5,  0.2,
            // Top
            -1.097,  1.5,  0.2,
             1.097,  1.5,  0.2,
             1.097,  1.5, -0.2,
            -1.097,  1.5, -0.2,
            // Bottom
            -1.097, -1.5, -0.2,
             1.097, -1.5, -0.2,
             1.097, -1.5,  0.2,
            -1.097, -1.5,  0.2,
            // Right
             1.097, -1.5,  0.2,
             1.097, -1.5, -0.2,
             1.097,  1.5, -0.2,
             1.097,  1.5,  0.2,
            // Left
            -1.097, -1.5, -0.2,
            -1.097, -1.5,  0.2,
            -1.097,  1.5,  0.2,
            -1.097,  1.5, -0.2
        ],
        element: [
            // Front
             0,  1,  2,
             0,  2,  3,
            // Top
             4,  5,  6,
             4,  6,  7,
            // Bottom
             8,  9, 10,
             8, 10, 11,
            // Right
            12, 13, 14,
            12, 14, 15,
            // Left
            16, 17, 18,
            16, 18, 19,
        ],
        texture: [
            // Front
            0.171, 0.861,
            0.829, 0.861,
            0.829, 0.139,
            0.171, 0.139,
            // Top
            0.171, 0.139,
            0.829, 0.139,
            0.829, 0.043,
            0.171, 0.043,
            // Bottom
            0.171, 0.957,
            0.829, 0.957,
            0.829, 0.861,
            0.171, 0.861,
            // Right
            0.829, 0.861,
            0.949, 0.861,
            0.949, 0.139,
            0.829, 0.139,
            // Left
            0.054, 0.861,
            0.171, 0.861,
            0.171, 0.139,
            0.054, 0.139
        ],
        svgReference: svgReference,
        updateFrequency: 'regular',
        vertexNormal: [
            // Front
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            // Top
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            // Bottom
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            // Right
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            // Left
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0
        ],
      },
      boxBottom: {
        position: [
            // Back
            -1.097, -1.5, -0.2,
            -1.097,  1.5, -0.2,
             1.097,  1.5, -0.2,
             1.097, -1.5, -0.2
         ],
        element: [
            // Back
             0,  1,  2,
             0,  2,  3,
        ],
        color: [ 0.95, 0.95, 0.95 ],
        vertexNormal: [
            // Front
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
        ],
      }
    };
    super(canvas, model, options);
  }
}
